import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import Review from 'modules/documents/store/models/Review'

class Reviews extends Collection<Review> {
  get indexes() {
    return ['reviewable_type', 'reviewable_id']
  }

  model() {
    return Review
  }

  filterByDocument(documentId: number | undefined): Review[] {
    return this.filter({
      reviewable_type: 'Document',
      reviewable_id: documentId,
    })
  }
}

// TODO: Deprecate
const singleton: Reviews = new Reviews()
export default singleton

const { provider: ReviewsProvider, hook: useReviews } = createCollectionContext<Review, Reviews>()
